// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__2oByb"};